import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({selector: 'ng1-upgraded-angular-js'})
export class Ng1UpgradedAngularJsWrapper extends UpgradeComponent {
// The names of the input and output properties here must match the names of the
  // `<` and `&` bindings in the AngularJS component that is being wrapped
  @Input() inputParam!: string;
  @Output() outputParam!: EventEmitter<boolean>;

  constructor(elementRef: ElementRef, injector: Injector) { 
    // We must pass the name of the directive as used by AngularJS to the super
    super('upgradedAngularJsCtrl', elementRef, injector)
  }
}
